import type { MarketplaceEntityForProductCardType as MarketplaceEntity } from '@ria-client/supergraph/structuredContent/hydration/MarketplaceProductCard/types';

export interface DriversProps {
  drivers: Array<MarketplaceEntity['driverFees']>;
}

export function Drivers({ drivers }: DriversProps) {
  return (
    <div className="mt-6 flex flex-col gap-4 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-6">
      {drivers.map(driver => (
        <div className="flex flex-col bg-muted p-6 sm:bg-transparent sm:p-0" key={driver.id}>
          <h4 className="pb-2 text-xs font-bold uppercase tracking-[1.44px]">{driver.label}</h4>
          <p className="text-2xl">{driver.value}</p>
          {driver.description && <p className="typography-text-small">{driver.description}</p>}
        </div>
      ))}
    </div>
  );
}
